<div class="flex flex-row">
  <div class="flex flex-col">
  <span class="text-white" matSnackBarLabel>
{{ data.title }}
  </span>
    <span class="text-white" matSnackBarLabel>
{{ data.message }}
  </span>
  </div>
  <span matSnackBarActions>
  <button mat-button matSnackBarAction (click)="snackBarRef.dismissWithAction()">Cerrar</button>
</span>

</div>
